<template>
  <div class="wrapper">
    <div class="titleBar">
      <strong>试卷名称</strong>
      <span class="greyFont">《{{ examName }}》</span>
    </div>
    <div class="searchBar">
      <div class="leftSide">
        <el-input placeholder="请输入考生姓名" v-model="searchCondition.name">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <el-pagination
          layout="prev, pager, next"
          :current-page.sync="searchCondition.jumpPage"
          :page-size.sync="searchCondition.pageSize"
          :total="searchCondition.total"
          @current-change="searchExamRecordList"
        >
        </el-pagination>
      </div>
      <div class="rightSide">
        <el-button
          type="primary"
          icon="el-icon-plus"
          plain
          @click="goTo('detail')"
          >查看考试记录</el-button
        >
        <el-button type="primary" icon="el-icon-receiving" @click="goTo('list')"
          >返回列表</el-button
        >
      </div>
    </div>
    <div class="monitorContainer">
      <div
        class="monitorCell"
        v-for="(item, index) in recordList"
        :key="'monitor' + index"
      >
        <div class="actBar">
          <el-button type="danger" size="small" @click="forceSubmit(item)">
            强制交卷</el-button
          >
        </div>
        <div class="monitorBar">
          <img
            alt=""
            :src="
              'https://' +
              $oss.options.bucket +
              '.' +
              $oss.options.endpoint.host +
              '/' +
              item.photoPath +
              monitorPicName
            "
            class="monitorImg"
          />
          <!-- <video
            muted
            class="monitorVideo"
            :id="'monitorVideo' + item.mobile"
            autoplay
          ></video> -->
          <img
            alt=""
            :src="
              'https://' +
              $oss.options.bucket +
              '.' +
              $oss.options.endpoint.host +
              '/' +
              item.h5IconPath +
              monitorPicName
            "
            class="monitorImg"
          />
        </div>
        <div class="detailBar">
          考生姓名：{{ item.name }} &nbsp;&nbsp; 组名称：{{ item.groupName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import appmonitor from "@/views/antiCheating/minitor.vue";
import { videoWall, forceSubmitexam } from "@/api/examination/examination.js";
import flvjs from "flv.js";
export default {
  data() {
    return {
      count: 20,
      searchCondition: {
        pageSize: 6,
        jumpPage: 1,
        name: "",
        examId: "",
        total: 0,
      },
      hour: "",
      min: "",
      sec: "",
      frame: "",
      minitorInterval: "",
      timeInitInterval: null,
      recordList: [],
      examName: "",
    };
  },
  components: {},
  computed: {
    monitorPicName() {
      return `/${this.hour}-${this.min}-${this.sec}-${this.frame}.png`;
    },
  },
  created() {},
  mounted() {
    this.searchCondition.examId = this.$route.query.examId;
    this.searchExamRecordList();
  },
  beforeDestroy() {
    clearInterval(this.minitorInterval);
  },
  methods: {
    goTo(type) {
      switch (type) {
        case "list":
          this.$router.push({ name: "examination-list" });
          break;
        case "detail":
          this.$router.push({
            name: "examEdit",
            query: { id: this.searchCondition.examId },
          });
          break;
        default:
          break;
      }
    },
    forceSubmit(item) {
      this.$confirm(`确认强制交卷吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        forceSubmitexam({ recordId: item.recordId }).then((data) => {
          this.$message.success("强制交卷成功");
          this.searchExamRecordList();
        });
      });
    },
    searchExamRecordList() {
      videoWall(this.searchCondition).then((data) => {
        this.recordList = data.dtoList;
        this.examName = data.examName;
        this.searchCondition.total = data.total;
        setTimeout(this.monitorInit);
        this.timeInit();
        this.intervalInit();
      });
    },
    timeInit() {
      let now = new Date(),
        hour = now.getHours(),
        min = now.getMinutes(),
        sec = now.getSeconds() - 6,
        frame = 0;
      if (sec < 0) {
        sec += 60;
        min--;
        if (min < 0) {
          min += 60;
          hour--;
          if (hour < 0) {
            hour += 24;
          }
        }
      }
      Object.assign(this.$data, { hour, min, sec, frame });
      console.log("时间重置");
    },
    intervalInit() {
      clearInterval(this.minitorInterval);
      clearInterval(this.timeInitInterval);
      this.minitorInterval = setInterval(() => {
        this.frame++;
        if (this.frame > 2) {
          this.frame = 0;
          this.sec++;
          if (this.sec == 60) {
            this.sec = 0;
            this.min++;
            if (this.min == 60) {
              this.min = 0;
              this.hour++;
              if (this.hour == 24) {
                this.hour = 0;
              }
            }
          }
        }
        console.log(this.monitorPicName);
      }, 333);
      this.timeInitInterval = setInterval(this.timeInit, 30000);
    },
    monitorInit() {
      if (flvjs.isSupported()) {
        this.recordList.forEach((item) => {
          let videoElement = document.getElementById(
            "monitorVideo" + item.mobile
          );
          let flvPlayer = flvjs.createPlayer({
            type: "flv",
            isLive: true,
            // hasAudio: true,
            // hasVideo: true,
            // enableStashBuffer: true,
            url: item.videoStreamUrl,
          });
          flvPlayer.attachMediaElement(videoElement);
          flvPlayer.load();
          flvPlayer.play();
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  background: #fff;
  min-height: calc(100vh - 140px);
  .greyFont {
    color: #999;
  }
  .titleBar {
    padding: 16px;
    border-bottom: 1px solid #ccc;
  }
  .searchBar {
    padding: 16px;
    display: flex;
    border-bottom: 1px solid #ccc;
    justify-content: space-between;
  }
  .monitorContainer {
    padding: 16px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .monitorCell {
      width: 32%;
      margin-bottom: 20px;
      background: #fff;
      border: 1px solid #ccc;
      .monitorBar {
        display: flex;
        width: 100%;
        height: 180px;
        align-items: center;
        justify-content: space-between;
        .monitorImg {
          width: 48%;
          height: auto;
          max-height: 180px;
          object-fit: contain;
        }
        .monitorVideo {
          width: 48%;
          height: auto;
          max-height: 180px;
          height: 150px;
          object-fit: contain;
        }
      }
      .detailBar {
        text-align: center;
        line-height: 50px;
        font-size: 1.15em;
      }
      .actBar {
        padding: 10px;
      }
    }
  }
}
</style>
